import React from 'react';
import {connect} from "react-redux";
import {Redirect, Route, Switch} from "react-router-dom";
import Finalize from "./round-03/finalize";
import Category from "./round-03/category";
import Categories from "./round-03/categories";
import Summary from "./round-03/summary";
import Loading from "game/app/components/layout/loading";
import GameComponent from "game/app/components/game/game-component";
import MainComponent from "./round-01/main-component";

class Round03Node extends GameComponent {

    render() {
        if (this.props.knowledgeQuestions.list === null || this.props.knowledgeQuestions.loading) {
            return (<Loading/>);
        }

        return (
            <Switch>
                <Route path='/game/:instance_id/round-3/finalize' component={Finalize}/>
                <Route path='/game/:instance_id/round-3/otazky/:category_id' component={Category}/>
                <Route path='/game/:instance_id/round-3/otazky' component={Categories}/>
                <Route path='/game/:instance_id/round-3/rozpocet' component={Summary}/>
                <Route path='/game/:instance_id/round-3/rodina' component={MainComponent}/>
                <Redirect to={`/game/${this.getInstanceId()}/round-3/rozpocet`}/>
            </Switch>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions
    };
}

export default connect(mapStateToProps)(Round03Node);
